



















































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";
import debounce from "@/common/debounce";


@Component({
  components: {
    Footer, Header
  },
})
export default class Logistics extends Vue {
  options: any = {}

  player: any;


  content1Title1: string = '制造企业数智物流平台-斯诺货运通'
  content1Title2: string = '改变传统物流管理方式'
  content1Title3: string = '改变传统物流管理方式，助力制造企业高效管车、精细管账'
  content2Title: string = '制造企业'
  content2Title2: string = '物流管理痛点'
  content2SubTitle: string = '集团物流运输需求日益增加，运输模式转型迫在眉睫'
  content2ContentTitle: string = '针对制造企业集团业务的快速增长，集团的物流运输需求日益增加，缺少物流运输的全流程管理\n各环节缺乏监管与沟通等痛点，物流运输模式的转换迫在眉睫'
  content2ContentList: any = [
    {
      img: `/static/compress-img/product/logistics/2/1.png`,
      title: "物流全流程难掌控",
      content: "装卸货和健康监测时间延长，货车通行便利度下降，物流时效和履约水平显著降低，企业无法及时跟踪运输进度",
    },
    {
      img: `/static/compress-img/product/logistics/2/2.png`,
      title: "缺乏物流管理理念",
      content: "物流服务的认识不全面，把现有的储运情况当做是企业物流的全部内容，却忽略了物流绩效能够给企业带来的增值效益",

    },
    {
      img: `/static/compress-img/product/logistics/2/3.png`,
      title: "管理主体多",
      content: "多家第三方物流服务商，服务质量各异，难以统一；服务商运力平衡难度大，运力过剩和短缺情况频发",
    },
    {
      img: `/static/compress-img/product/logistics/2/4.png`,
      title: "信息化程度不高",
      content: "缺乏先进的物流平台系统支持，在交叉配送时容易造成混乱局面，直接增加物流运输、配送成本",
    },
    {
      img: `/static/compress-img/product/logistics/2/5.png`,
      title: "物流成本持续升高",
      content: "物流成本高导致价格升高，顾客满意度也会下降；控制物流成本也是提高客户满意度的重要途径，也是增加企业竞争力的重要保障",
    },
    {
      img: `/static/compress-img/product/logistics/2/6.png`,
      title: "上下游企业协同难",
      content: "高度整合上下游，上下游企业协同互动，解决供应链管理各环节信息不对称、不明确，打破制造业企业与物流企业之间的屏障，实现共赢",
    },

  ]
  content2List: any = [
    {
      img: `/static/compress-img/product/logistics/2-1.png`,
      title: "制造企业端",
      content: "全场景化功能按需选配",
    },
    {
      img: `/static/compress-img/product/logistics/2-2.png`,
      title: "承运商端",
      content: "运力资源便捷调度",
    },
    {
      img: `/static/compress-img/product/logistics/2-3.png`,
      title: "司机端",
      content: "运输过程全程管控",
    },
    {
      img: `/static/compress-img/product/logistics/2-4.png`,
      title: "客户端",
      content: "订单在途实时查询",
    },
  ]
  content3Title: string = '制造企业业务痛点'
  content3SubTitle: string = '集团物流运输需求日益增加，运输模式转型迫在眉睫'
  content3List: any = [
    {
      img: `/static/compress-img/product/logistics/3-1.png`,
      title: "物流全流程难掌控",
      content: "核酸检测、装卸货时间延长，物流时效和履约水平降低，企业无法及时跟踪运输进度",
    },
    {
      img: `/static/compress-img/product/logistics/3-2.png`,
      title: "缺乏物流管理理念",
      content: "物流服务的认识不全面，忽略了物流绩效能够给企业带来的增值效益",
    },
    {
      img: `/static/compress-img/product/logistics/3-3.png`,
      title: "物流成本持续升高",
      content: "物流成本高导致价格升高，顾客满意度也会下降；控制物流成本已经迫在眉睫",
    },
    {
      img: `/static/compress-img/product/logistics/3-4.png`,
      title: "信息化程度不高",
      content: "缺乏先进的物流平台系统支持，在交叉配送时容易增加物流运输、配送成本",
    },
    {
      img: `/static/compress-img/product/logistics/3-5.png`,
      title: "库存周期长、成本高",
      content: "交通中断导致企业产品无法进入市场销售，库存的积压也导致企业仓储和保管成本增加",
    },
    {
      img: `/static/compress-img/product/logistics/3-6.png`,
      title: "上下游企业协同难",
      content: "上下游企业协同互动，解决供应链管理各环节信息不对称、不明确等问题，打破屏障，实现共赢",
    },
  ]
  content4Title: string = '了解更多货运通产品'
  content4SubTitle: string = '由集团进行统一管控，形成集团化物流管理新模式，提高企业物流管理能力，降低企业运输成本';
  content5Title1: string = '核心功能'
  content5Title2: string = '物流运输的全流程管理'
  content5SubTitle: string = '支持PC、APP、小程序多端数据共通'
  content5List: any = [
    {
      title: '询价招标',
      img: '/static/compress-img/product/logistics/4/1.png',
      bimg: '/static/compress-img/product/logistics/4/b/1.png',
      wimg: '/static/compress-img/product/logistics/4/w/1.png',
    },
    {
      title: '发运管理',
      img: '/static/compress-img/product/logistics/4/2.png',
      bimg: '/static/compress-img/product/logistics/4/b/2.png',
      wimg: '/static/compress-img/product/logistics/4/w/2.png',
    },
    {
      title: '预约排队',
      img: '/static/compress-img/product/logistics/4/3.png',
      bimg: '/static/compress-img/product/logistics/4/b/3.png',
      wimg: '/static/compress-img/product/logistics/4/w/3.png',
    },
    {
      title: '物流追踪',
      img: '/static/compress-img/product/logistics/4/4.png',
      bimg: '/static/compress-img/product/logistics/4/b/4.png',
      wimg: '/static/compress-img/product/logistics/4/w/4.png',
    },
    {
      title: '财务结算',
      img: '/static/compress-img/product/logistics/4/5.png',
      bimg: '/static/compress-img/product/logistics/4/b/5.png',
      wimg: '/static/compress-img/product/logistics/4/w/5.png',
    },
    {
      title: '承运商KPI',
      img: '/static/compress-img/product/logistics/4/6.png',
      bimg: '/static/compress-img/product/logistics/4/b/6.png',
      wimg: '/static/compress-img/product/logistics/4/w/6.png',
    },
    {
      title: '运力管理',
      img: '/static/compress-img/product/logistics/4/7.png',
      bimg: '/static/compress-img/product/logistics/4/b/7.png',
      wimg: '/static/compress-img/product/logistics/4/w/7.png',
    },
  ]
  content5RightImg: string = this.content5List[0].img
  content5Index:number=0;
  changeContent5Img1(item, index) {
    this.timer3Runing=false;
    if (item && item.img) {
      this.content5Index=index;
      this.content5RightImg = item.img
    }
  }
  changeContent5Img2(item, index) {
    // this.timer3Runing=false;
    if (item && item.img) {
      this.content5Index=index;
      this.content5RightImg = item.img
    }
  }

  content6Title: string = '特色服务'
  content6SubTitle: string = '多层面解决当前物流行业的难点痛点'
  content6List: any = [
    {
      img: `/static/compress-img/product/logistics/4/1.png`,
      title: "自有运力管控",
      content: "汇聚企业和承运商的运力资源，形成企业的自有运力池，运力信息维护、司机实名认证、车辆信息管理",
    },
    {
      img: `/static/compress-img/product/logistics/6-2.png`,
      title: "物流追溯",
      content: "订单下发同步创建标识码，一键分享至上、下游，通过扫码方式，追踪运输动态，防范在途运输风险",
    },
    {
      img: `/static/compress-img/product/logistics/6-3.png`,
      title: "智能监控",
      content: "运输方案智能推荐、智能拆/并单、预测运价、异常事件预警等",
    },

  ]

  content7CenterTitle1: string = '实时监控业务指标，发挥数据价值'
  content7CenterTitle2: string = '数据驾驶舱'

  content8Title: string = '应用价值'
  content8SubTitle: string = '规范管理、标准作业、全局管控'
  content8List: any = [
    {
      title: '集成式管理平台',
      img: '/static/compress-img/product/logistics/8-1.png'
    },
    {
      title: '便捷式业务操作',
      img: '/static/compress-img/product/logistics/8-2.png'
    },
    {
      title: '畅通的沟通渠道',
      img: '/static/compress-img/product/logistics/8-3.png'
    },
    {
      title: '完善的预约系统',
      img: '/static/compress-img/product/logistics/8-4.png'
    },
    {
      title: '运单精准定位',
      img: '/static/compress-img/product/logistics/8-5.png'
    },
    {
      title: '财务规范管理',
      img: '/static/compress-img/product/logistics/8-6.png'
    },
    {
      title: '大数据+智能商业分析',
      img: '/static/compress-img/product/logistics/8-7.png'
    },
    {
      title: '多系统集成化',
      img: '/static/compress-img/product/logistics/8-8.png'
    },
  ]
  content9Title1: string = '货运通'
  content9Title2: string = '数智化物流平台'
  content9List: any = ['集团管理一体化', '业务场景全覆盖', '运单管理精准化']
  content9: string = '斯诺货运通可以为制造企业提供一站式的集团化物流管理，通过整合物流承运商资源，进行线上物流询价招投标，实时监管全物流发运过程，财务运费自动对账结算等，可由集团进行统一管控，形成集团化物流管理新模式，提高企业物流管理能力，降低企业运输成本。'
  content7CenterImg:string='/static/compress-img/product/logistics/7/xlfx.png';
  panelArray:any=['xlfx', 'sjfx', 'cbfx', 'cysfx', 'sxfx', 'jysjfx']
  panelLeftArray:any=['线路运价分析','司机用户画像','运力成本分析','承运商画像','商务时效分析','财务分析']
  panelLeftArray2:any=['运价趋势、运价排名等','地域、年龄、工龄','工资、油卡、车辆维修等','承运资质、报价统计、承运统计','询价、中标、回款、对账等','应收应付、盈利能力、资金计划等']
  panelLeftNumber:string=this.panelLeftArray[0]
  panelLeftNumber2:string=this.panelLeftArray2[0]
  panelRightArray:any=['热门线路分析','司机KPI考核','业务成本分析','承运商考核','运输时效分析','资产分析']
  panelRightArray2:any=['运输排名、实时订单分析','准点率、投诉率、货损率等','利润率、货损、仓储等','运输时效、运输质量、现场管理','计划、派单、派车、装卸、运输等','存货周转、资产盘活、风险预警等']
  panelRightNumber:string=this.panelRightArray[0]
  panelRightNumber2:string=this.panelRightArray2[0]


  hoverItemChange(item,status=true){
    this.timer12Runing=status;
    let index=this.panelArray.findIndex((value)=>{
      return value==item;
    })
    this.panelLeftNumber=this.panelLeftArray[index];
    this.panelLeftNumber2=this.panelLeftArray2[index];
    this.panelRightNumber=this.panelRightArray[index];
    this.panelRightNumber2=this.panelRightArray2[index];
    this.panelIndex=index;
    this.content7CenterImg='/static/compress-img/product/logistics/7/'+item+'.png'
  }
  content7LeftArrowIndex=0;
  content7LeftArrowList:any=['/static/compress-img/product/logistics/7/1/l1.png','/static/compress-img/product/logistics/7/1/l2.png','/static/compress-img/product/logistics/7/1/l3.png','/static/compress-img/product/logistics/7/1/l1.png','/static/compress-img/product/logistics/7/1/l2.png','/static/compress-img/product/logistics/7/1/l3.png'];
  content7RightArrowList:any=['/static/compress-img/product/logistics/7/1/r1.png','/static/compress-img/product/logistics/7/1/r2.png','/static/compress-img/product/logistics/7/1/r3.png','/static/compress-img/product/logistics/7/1/r1.png','/static/compress-img/product/logistics/7/1/r2.png','/static/compress-img/product/logistics/7/1/r3.png'];
  content9Top:number=0
  content9Height:number=0
  isPlay:boolean=false
  mounted() {
    this.initMoive()
    this.setTimer()
    this.setTimer2()
    this.setTimer3()
    var content9 = document.getElementById('content9');
    // debugger
    this.content9Height=content9.clientHeight;
    this.content9Top= content9.offsetTop;
    let that=this;
    $(window).scroll(function () {
      debounce(()=>{

        if (!that.$route.path.includes('logistics')){
          return;
        }
        if (that.isPlay){
          return
        }
        if ($(window).scrollTop() > that.content9Top-that.content9Height) {
          that.isPlay=true
          if (that.player) {
            if (that.player.hasStarted_){
              return;
            }
            that.player.play()
          }
        }
      },{},0)
    })

  }
  beforeDestroy(){
    this.clearTimer()
    this.clearTimer2()
    this.clearTimer3()
    if (this.player) {
      this.player.pause()
    }
  }

  initMoive() {
    this.player = this.$video(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
    })
  }
  timer1:any;
  timer2:any;
  timer3:any;
  timer1Runing:boolean=true;
  timer2Runing:boolean=true;
  timer3Runing:boolean=true;
  timer12Runing:boolean=true;
  setTimer(){
    this.clearTimer();
    this.timer1 = setInterval(() => {
      // console.log(this.player.hasStarted_)
      // console.log(this.player.isAudio)
      if (!this.timer12Runing){
        return;
      }
      if (this.content7LeftArrowIndex==2){
        this.content7LeftArrowIndex=0;
      }else{
        this.content7LeftArrowIndex++;
      }
    }, 500);
  }
  clearTimer(){
    clearInterval(this.timer1);
  }
  panelIndex:number=0
  setTimer2(){
    this.clearTimer2();
    this.timer2 = setInterval(() => {
      if (!this.timer12Runing){
        return;
      }
      this.panelIndex++;
      if (this.panelIndex>=this.panelArray.length){
        this.panelIndex=0;
      }
      this.hoverItemChange(this.panelArray[this.panelIndex])
    }, 3000);
  }
  clearTimer2(){
    clearInterval(this.timer2);
  }
  setTimer3(){
    this.clearTimer3();
    this.timer3 = setInterval(() => {
      if (!this.timer3Runing){
        return;
      }
      if(this.content5Index===6){
        this.content5Index=0;
      }else{
        this.content5Index++;
      }
      this.changeContent5Img2(this.content5List[this.content5Index],this.content5Index)
    }, 3000);
  }
  clearTimer3(){
    clearInterval(this.timer3);
  }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/product/Logistics.vue